import React from 'react'
import PropTypes from 'prop-types'
import {BarElement, CategoryScale, Chart as ChartJS, LinearScale, Title, Tooltip} from "chart.js"
import {Bar} from "react-chartjs-2"


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip)

const options = {
    maintainAspectRatio: true,
    responsive: true,
    datasets: {
        bar: {
            barPercentage: 0.9,
        },
    },
    scales: {
        x: {
            border:  {
                width: 2,
                color: 'black',
            },
            grid: {
                display: false,
            },
        },
        y: {
            display: false,
            grid: {
                drawBorder: false,
            },
            ticks: {
                callback: (value) => (value.toLocaleString("de-DE", {
                    minimumFractionDigits: 0,
                }) + " EUR")
            },
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
        tooltip: {
            enabled: false,
        },
    },
}

const TpUiParallelBarChart = ({data}) => <Bar type="bar" options={options} data={data}/>

TpUiParallelBarChart.propTypes = {
    data: PropTypes.exact({
        labels: PropTypes.arrayOf(PropTypes.string),
        datasets: PropTypes.arrayOf(
            PropTypes.exact({
                label: PropTypes.string,
                data: PropTypes.arrayOf(PropTypes.string),
                backgroundColor: PropTypes.string,
            }),
        ),
    }),
}

export default TpUiParallelBarChart
